import speakeasy from "speakeasy";
import QRCode from "qrcode";
import store from "../../store";

export const GoogleAuthenticator = {
  methods: {
    getMFA() {
      return store.dispatch("getMFAEnabled");
    },
    setMFA(mfaValue) {
      return store.dispatch("setMFAEnabled", { mfaResponse: mfaValue });
    },
    generateSecret() {
      // var secret = {
      //   ascii: "tsrwO${Q)DUSb#3A*Ru]kgqq.9y#ac!a",
      //   hex: "747372774f247b5129445553622333412a52755d6b6771712e39792361632161",
      //   base32: "ORZXE52PER5VCKKEKVJWEIZTIEVFE5K5NNTXC4JOHF4SGYLDEFQQ",
      //   otpauth_url: "otpauth://totp/SonomedEscalon?secret=ORZXE52PER5VCKKEKVJWEIZTIEVFE5K5NNTXC4JOHF4SGYLDEFQQ"
      // };
      var secret = speakeasy.generateSecret();
      return store.dispatch("setMFASecret", {
        secret: JSON.stringify(secret)
      });
    },
    getSecretFromAPI() {
      return store.dispatch("getMFASecret")
        .then(response => JSON.parse(response.data));
    },
    getSecret() {
      return this.getSecretFromAPI().then(secret => secret.base32);
    },
    getQRCode() {
      return this.getSecretFromAPI()
        .then(secret => {
          var qrurl;
          QRCode.toDataURL(secret.otpauth_url, ( _, data_url ) => {
            qrurl = data_url;
          });
          return qrurl;
        });
    },
    getHex() {
      return this.getSecretFromAPI().then(secret => secret.hex);
    },
    checkCode(userToken) {
      return this.getHex().then(result => {
        return speakeasy.totp.verify({
          secret: result,
          encoding: "hex",
          token: userToken
        });
      });
    }
  }
};
